import { Map as ImmutableMap, Record } from 'immutable';
export const ArticleCountsRecord = Record({
  counts: ImmutableMap(),
  error: null,
  isRequesting: false,
  lastLoaded: null
});
export default ArticleCountsRecord;